import { environment } from "./environment.base";
export { environment };

environment.name = 'qa';
environment.parentUrl =  'https://qa.strayos.com';
environment.baseUrl = 'https://qadashboards.strayos.com';
environment.apiUrl = 'https://devx.strayos.com:3012';
// environment.apiUrl = 'https://devx.strayos.com:3020';